module.exports = __webpack_public_path__ + "img/advice-7.51f9a28f.png";